import { TypographySM } from "@/components/typography/SM";
import { motion, useAnimate, usePresence } from "framer-motion";
import { Check, WifiOff } from "lucide-react";
import { useEffect } from "react";

export function NetworkErrorBanner() {
  const [isPresent, safeToRemove] = usePresence();
  const [scope, animate] = useAnimate<HTMLDivElement>();

  useEffect(() => {
    if (!scope) return;

    if (isPresent) {
      const enterAnimation = async () => {
        // reset from exitAnimation changes
        await animate(scope.current, { backgroundColor: "rgb(206 155 56)" });
        await animate("#errorText", { display: "block" });
        await animate("#errorIcon", { visibility: "visible" });
        await animate("#successText", { display: "none" });
        await animate("#successIcon", { visibility: "hidden" });

        animate(scope.current, { transform: "translateY(0)" });
      };

      enterAnimation();
    } else {
      const exitAnimation = async () => {
        animate("#successText", { display: "block" });
        animate("#errorText", { display: "none" });

        animate("#errorIcon", { visibility: "hidden" });
        animate("#successIcon", { visibility: "visible" });

        await animate(
          scope.current,
          { backgroundColor: "rgb(56 189 248)" },
          { duration: 0.2 }
        );

        await animate(
          scope.current,
          { transform: "translateY(-100%)" },
          { delay: 3 }
        );

        safeToRemove();
      };

      exitAnimation();
    }
  }, [animate, isPresent, safeToRemove, scope]);

  return (
    <motion.div
      ref={scope}
      className="absolute top-0 left-0 -translate-y-full right-0 py-3 px-3 bg-brand-warning flex items-center justify-center"
    >
      <div id="iconBox" className="relative mr-3">
        <WifiOff className="absolute" id="errorIcon" size={20} />
        <Check className="invisible" id="successIcon" size={20} />
      </div>
      <div className="relative">
        <TypographySM id="errorText">
          Lost connection to the server. Please check your internet connection.
        </TypographySM>
        <TypographySM id="successText" className="hidden">
          Connected to the server
        </TypographySM>
      </div>
    </motion.div>
  );
}
